var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.photos
    ? _c(
        "section",
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "carousel",
                  {
                    attrs: {
                      perPage: _vm.$mq.phone ? 2 : 3,
                      autoplay: false,
                      centerMode: false,
                      autoplayHoverPause: true,
                      navigationEnabled: true,
                      paginationEnabled: false,
                      loop: true,
                      autoplayTimeout: 3000,
                      scrollPerPage: false,
                      mouseDrag: true,
                      touchDrag: true
                    }
                  },
                  [
                    _vm._l(_vm.photos, function(photo, index) {
                      return [
                        _c(
                          "slide",
                          {
                            on: {
                              slideclick: function($event) {
                                return _vm.setGalleryIndex(index)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "m-2 pointer-item" }, [
                              _c("div", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy:background-image",
                                    value: photo.image_xl,
                                    expression: "photo.image_xl",
                                    arg: "background-image"
                                  }
                                ],
                                staticClass: "image-container"
                              })
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.includeGallery
            ? _c("Tinybox", {
                staticStyle: { "z-index": "9999" },
                attrs: {
                  images: _vm._.map(_vm.photos, "image_xl"),
                  loop: "",
                  "no-thumbs": ""
                },
                model: {
                  value: _vm.galleryIndex,
                  callback: function($$v) {
                    _vm.galleryIndex = $$v
                  },
                  expression: "galleryIndex"
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50f71dc6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f71dc6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/PhotosAlbum.vue
// module id = 1630
// module chunks = 0